import React, { useEffect, useMemo } from "react";
import { Tabs } from "../Tabs";
import {
  TEMPLATE_LAYOUT,
  TEMPLATE_LAYOUT_OPTIONS,
} from "../../constants/dashboard";

import { useDispatch } from "react-redux";
import { setActiveLayout } from "../../store/templates/templatesSlice";
import { useSelector } from "react-redux";
import {
  loadHorizontalVideoTemplates,
  loadVerticalVideoTemplates,
} from "../../thunks/dashboardThunks";
import { PAGINATION_OFFSET } from "../../utils/general";
import Loader from "../common/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import { getTileImage } from "../../utils";
import { setSelectedVideo } from "../../store/Subtitle/subTitleSlice";

const VideoSelection = () => {
  const dispatch = useDispatch();
  const { selectedVideo = {} } = useSelector((state) => state.subTitle);
  const handleTabChange = (value) => dispatch(setActiveLayout(value));
  const {
    verticalVideoTemplates,
    horizontalVideoTemplates,
    activeLayout,
    hasMoreHorizontalVideoTemplates,
    hasMoreVerticalVideoTemplates,
  } = useSelector((state) => state.templates);
  const isVerticalLayout = useMemo(
    () => activeLayout === TEMPLATE_LAYOUT.VERTICAL,
    [activeLayout]
  );

  const hasMore = useMemo(() => {
    if (isVerticalLayout) {
      return hasMoreVerticalVideoTemplates;
    }
    return hasMoreHorizontalVideoTemplates;
  }, [
    isVerticalLayout,
    hasMoreVerticalVideoTemplates,
    hasMoreHorizontalVideoTemplates,
  ]);
  const isHorizontalLayout = useMemo(
    () => activeLayout === TEMPLATE_LAYOUT.HORIZONTAL,
    [activeLayout]
  );
  const filteredVideos = useMemo(() => {
    return isVerticalLayout ? verticalVideoTemplates : horizontalVideoTemplates;
  }, [verticalVideoTemplates, horizontalVideoTemplates, isVerticalLayout]);

  useEffect(() => {
    fetchMore(0);
  }, [isHorizontalLayout, isVerticalLayout]);
  const fetchMore = (page) => {
    if (isVerticalLayout) {
      dispatch(loadVerticalVideoTemplates(page || 0));
    }
    if (isHorizontalLayout) {
      dispatch(loadHorizontalVideoTemplates(page || 0));
    }
  };

  const infinateScroll = () => {
    const currentPage = filteredVideos.length / PAGINATION_OFFSET;
    return fetchMore(currentPage, true);
  };

  return (
    <div className="bg-[#F4F3F6] h-[467px]] w-[506px] p-[15px] pt-5">
      <div className="font-semibold text-sm	text-[#11142DB2] pb-[11px]">
        Select a video
      </div>
      <div className="w-fit pb-[10px]">
        <Tabs
          tabs={TEMPLATE_LAYOUT_OPTIONS}
          handleTabChange={handleTabChange}
          currentActiveTab={activeLayout}
        />
      </div>
      <div className="relative rounded-lg border border-[#0000004D]">
        <InfiniteScroll
          dataLength={filteredVideos?.length}
          next={infinateScroll}
          hasMore={hasMore}
          // loader={
          //   <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          //     <Loader isDark isStack hideOverlay />
          //   </div>
          // }
          height={286}
        >
          <div className="h-[287px] pt-5 pl-3">
            <div className="flex flex-wrap gap-3">
              {filteredVideos.map((item, index) => {
                return (
                  <div
                    className={`w-fit cursor-pointer`}
                    onClick={() => {
                      dispatch(setSelectedVideo(item));
                    }}
                  >
                    <video
                      src={`${getTileImage(item)}`}
                      alt="video"
                      className={`rounded-md max-w-[137px] bg-white h-[80px] ${
                        selectedVideo.id === item.id && "selected-card"
                      }`}
                    />
                    <div className="font-semibold text-xs text-[#11142DB2] pt-[6px]">
                      {item.projectName}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default VideoSelection;
